/* Widget kontaktowy Gym Glamour - dymek w rogu sklepu + panel z formularzem.
   Rozmawia wylacznie z Workerem spod KONF.api, nigdy bezposrednio z kontaktem. */
(() => {
  "use strict";

  // Asset motywu potrafi wejsc dwa razy (layout + sekcja) - drugi raz nic nie robimy.
  if (window.GGWidget) return;

  const KONF = Object.assign(
    { lang: "PL", rynek: "PL", api: "https://widget.gymglamour.eu" },
    window.GG_WIDGET || {}
  );
  const API = String(KONF.api || "https://widget.gymglamour.eu").replace(/\/+$/, "");
  const RYNEK = String(KONF.rynek || "PL").toUpperCase();
  let jezyk = String(KONF.lang || "PL").toUpperCase();

  const MAX_PLIKOW = 5;
  const MAX_BAJTOW = 10 * 1024 * 1024;
  const KLUCZ_SZKICU = "ggw_szkic_v1";
  const TYPY_PLIKOW = ".jpg,.jpeg,.png,.gif,.webp,.heic,.heif,.pdf,.mp4,.mov";

  // Odpytujemy WYLACZNIE w trwajacej rozmowie - reszta ruchu czyta /stan z KV.
  const CZAS_ODPYTANIA = 2000;
  const LIMIT_BLEDOW = 3;
  const CZAS_STANU = 30000;

  // Wartosci tematow zostaja po polsku i sa niezalezne od jezyka - backend
  // rozpoznaje po nich sprawe. Klientka wybiera tylko, CZEGO dotyczy sprawa -
  // kategorie nadaje AI-triage po tresci.
  const TRYBY = { ogolne: "Inne", zamowienie: "Zapytanie o produkt" };

  const BLEDY = {
    brak_pol: "blad_brak_pol",
    zly_email: "blad_email",
    para_nie_pasuje: "blad_para",
    za_duzo_prob: "blad_limit",
    za_duzy_plik: "blad_plik",
    zly_typ_pliku: "blad_plik",
  };

  /* Teksty zapasowe - widget ma dzialac takze wtedy, gdy slownik nie zdazyl sie
     wczytac albo nie ma jeszcze klucza dla danego rynku. */
  const ZAPASOWE = {
    naglowek: "Napisz do nas",
    podtytul_offline: "To nie jest czat na żywo - odpowiemy mailem.",
    podtytul_godziny: "Godziny obsługi: {godziny}",
    pole_zamowienie: "Numer zamówienia",
    pole_zamowienie_hint: "np. GG91290 - jeśli piszesz w sprawie zamówienia",
    pole_email: "E-mail",
    pole_imie: "Imię",
    pole_wiadomosc: "Wiadomość",
    pole_pliki: "Dodaj zdjęcia lub pliki",
    przycisk_wyslij: "Wyślij wiadomość",
    przycisk_sprawdz_status: "Sprawdź status zamówienia",
    przycisk_mimo_to: "Wyślij mimo to",
    blad_brak_pol: "Uzupełnij e-mail i treść wiadomości.",
    blad_email: "Ten adres e-mail wygląda na niepoprawny.",
    blad_para: "Nie znaleźliśmy zamówienia dla tego adresu e-mail.",
    blad_limit: "Za dużo prób. Spróbuj ponownie za kilka minut.",
    blad_plik: "Plik jest za duży albo w nieobsługiwanym formacie.",
    wyslane_tytul: "Dziękujemy",
    wyslane_tresc: "Wiadomość do nas dotarła. Odpowiedź wyślemy na podany adres e-mail.",
    zamknij: "Zamknij",
    otworz: "Napisz do nas",
    /* Klucze dodatkowe (karta statusu, usuwanie pliku, blad ogolny). Slownik moze
       ich nie miec - wtedy widget uzywa tekstow ponizej. */
    blad_ogolny: "Nie udało się wysłać wiadomości. Spróbuj ponownie za chwilę.",
    przycisk_usun_plik: "Usuń plik",
    st_blad: "Nie udało się pobrać statusu zamówienia.",
    st_brak: "Nie mamy jeszcze szczegółów tego zamówienia.",
    st_anulowane: "Zamówienie anulowane.",
    st_paczki: "Paczki",
    st_dostarczona: "Dostarczona",
    st_w_drodze: "W drodze",
    st_przygotowanie: "W przygotowaniu w magazynie",
    st_sledz: "Śledź przesyłkę",
    st_zwroty: "Zwroty",
    st_zwrot_zarejestrowany: "Zwrot zarejestrowany",
    st_zwrot_w_toku: "Zwrot w toku",
    st_zwrot_zakonczony: "Pieniądze zwrócone",
    st_termin: "Termin: {data}",
    st_szczegoly: "Szczegóły",
    st_produkty: "Produkty",
    czat_zaproszenie: "Napisz do nas teraz, odpowiadamy na żywo",
    czat_podtytul: "Rozmowa na żywo z zespołem obsługi.",
    czat_start: "Rozpocznij rozmowę",
    czat_pole_wiadomosc: "Napisz wiadomość",
    czat_pisze: "Pisze wiadomość",
    czat_ostrzezenie: "Rozmowa zamknie się za chwilę, jeśli nie odpowiesz.",
    czat_zakonczony: "Rozmowa zakończona - zapis wysłaliśmy na Twój e-mail.",
    czat_wroc_do_formularza: "Wróć do formularza",
    czat_brak_operatora: "Nikt nie jest teraz wolny - zostaw wiadomość.",
    czat_brak_polaczenia: "Połączenie się urwało - dokończ w formularzu.",
    czat_ty: "Ty",
    czat_wysylanie: "Wysyłanie",
  };

  /* Slownik moze byc plaski ({klucz: tekst}) albo per jezyk ({PL: {...}}) -
     obslugujemy oba ksztalty, zeby nie wiazac sie z decyzja slownika. */
  const t = (klucz) => {
    const zrodlo = window.GG_WIDGET_I18N || {};
    const zestaw = zrodlo[jezyk] || zrodlo[jezyk.toLowerCase()] ||
      (typeof zrodlo.PL === "object" ? zrodlo.PL : zrodlo);
    const wartosc = zestaw && zestaw[klucz];
    return typeof wartosc === "string" ? wartosc : (ZAPASOWE[klucz] || klucz);
  };

  const esc = (x) => String(x == null ? "" : x).replace(/[&<>"']/g, (c) => (
    { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]
  ));

  // Do karty statusu wstrzykujemy adresy z odpowiedzi - przepuszczamy tylko http(s).
  const bezpiecznyUrl = (u) => (/^https?:\/\//i.test(String(u || "")) ? String(u) : "");

  // Tekst dymka -> HTML z klikalnymi linkami. Escapujemy CALOSC, potem podmieniamy
  // adresy - w escapowanym tekscie URL nie moze zawierac cudzyslowu ani <>, wiec
  // wstawienie go w href jest bezpieczne. Ogonki interpunkcji nie wchodza do linku.
  const linkujTekst = (tekst) => esc(tekst).replace(
    /https?:\/\/[^\s<>"']+/g,
    (u) => {
      const czysty = u.replace(/[.,;:!?)]+$/, "");
      const ogon = u.slice(czysty.length);
      return `<a href="${czysty}" target="_blank" rel="noopener noreferrer">${czysty}</a>${ogon}`;
    }
  );

  const dataPl = (iso) => {
    const [r, m, d] = String(iso || "").slice(0, 10).split("-");
    return d && m && r ? `${d}.${m}.${r}` : String(iso || "");
  };

  const IKONY = {
    czat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.5 11.6a8.2 8.2 0 0 1-8.8 8.2 9 9 0 0 1-3.6-.8L3.5 20.5l1.6-4.4a8.2 8.2 0 0 1 6.6-12.3 8.2 8.2 0 0 1 8.8 7.8z"/></svg>',
    krzyzyk: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    lupa: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
    spinacz: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21.2 11.1 12.1 20.2a5.4 5.4 0 0 1-7.6-7.6l9.1-9.1a3.6 3.6 0 0 1 5.1 5.1l-9.1 9.1a1.8 1.8 0 0 1-2.5-2.5l8.4-8.4"/></svg>',
    ptaszek: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m20 6-11 11-5-5"/></svg>',
    strzalka: '<svg class="ggw-status-strzalka" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>',
    samolot: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M21 3 3 10.5l7 3 3 7zM21 3l-11 10.5"/></svg>',
    paczka: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m7.5 4.3 9 5.2"/><path d="M21 16V8a2 2 0 0 0-1-1.7l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.7l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>',
  };

  const SZKIELET = `
<button type="button" class="ggw-dymek" aria-haspopup="dialog" aria-expanded="false">${IKONY.czat}<span class="ggw-dymek-badge" hidden></span></button>
<div class="ggw-panel" role="dialog" aria-modal="true" aria-labelledby="ggw-tytul" hidden>
  <div class="ggw-head">
    <div class="ggw-head-txt">
      <span class="ggw-tytul" id="ggw-tytul"></span>
      <span class="ggw-podtytul"></span>
    </div>
    <button type="button" class="ggw-x">${IKONY.krzyzyk}</button>
  </div>
  <div class="ggw-body">
    <form class="ggw-form" novalidate>
      <div class="ggw-zapros" hidden>
        <p class="ggw-zapros-tytul ggw-l-czat-zapros"></p>
        <p class="ggw-zapros-pod ggw-l-czat-pod"></p>
      </div>
      <p class="ggw-wybierz ggw-l-wybierz"></p>
      <div class="ggw-tryby" role="group">
        <button type="button" class="ggw-tryb ggw-tryb-zam" data-tryb="zamowienie" aria-pressed="false">${IKONY.paczka}<span class="ggw-l-tryb-zam"></span></button>
        <button type="button" class="ggw-tryb ggw-tryb-ogolne" data-tryb="ogolne" aria-pressed="false"><span class="ggw-l-tryb-ogolne"></span></button>
      </div>
      <div class="ggw-reszta" hidden>
      <label class="ggw-pole ggw-pole-zam" hidden>
        <span class="ggw-etykieta ggw-l-zam"></span>
        <input class="ggw-input" type="text" name="order_number" autocomplete="off" spellcheck="false">
        <span class="ggw-hint ggw-l-zam-hint"></span>
      </label>
      <label class="ggw-pole">
        <span class="ggw-etykieta ggw-l-email"></span>
        <input class="ggw-input" type="email" name="email" autocomplete="email" spellcheck="false">
      </label>
      <button type="button" class="ggw-status-btn" hidden><span class="ggw-status-ico">${IKONY.lupa}</span><span class="ggw-status-txt"><span class="ggw-l-status"></span><span class="ggw-status-hint ggw-l-status-hint"></span></span>${IKONY.strzalka}</button>
      <div class="ggw-status" aria-live="polite" hidden></div>
      <label class="ggw-pole">
        <span class="ggw-etykieta ggw-l-imie"></span>
        <input class="ggw-input" type="text" name="imie" maxlength="100" autocomplete="given-name">
      </label>
      <label class="ggw-pole">
        <span class="ggw-etykieta ggw-l-wiad"></span>
        <textarea class="ggw-input ggw-textarea" name="wiadomosc" rows="5" maxlength="5000"></textarea>
      </label>
      <div class="ggw-pliki">
        <button type="button" class="ggw-plik-btn">${IKONY.spinacz}<span class="ggw-l-pliki"></span></button>
        <input type="file" class="ggw-plik-input" multiple accept="${TYPY_PLIKOW}" hidden>
        <ul class="ggw-plik-lista"></ul>
      </div>
      <input type="text" class="ggw-hp" name="website" tabindex="-1" autocomplete="off" aria-hidden="true">
      <p class="ggw-blad" role="alert" hidden></p>
      <button type="submit" class="ggw-wyslij"></button>
      </div>
    </form>
    <div class="ggw-czat" hidden>
      <div class="ggw-czat-lista" aria-live="polite">
        <div class="ggw-bak ggw-bak-op ggw-kropki" hidden><span></span><span></span><span></span></div>
      </div>
      <p class="ggw-czat-uwaga" role="status"></p>
      <div class="ggw-czat-pisanie">
        <textarea class="ggw-czat-input" rows="1" maxlength="2000"></textarea>
        <button type="button" class="ggw-czat-wyslij">${IKONY.samolot}</button>
      </div>
      <button type="button" class="ggw-czat-zakoncz"></button>
      <div class="ggw-czat-koniec" hidden>
        <p class="ggw-czat-koniec-txt"></p>
        <button type="button" class="ggw-wyslij ggw-czat-wroc"></button>
      </div>
    </div>
    <div class="ggw-sukces" hidden>
      <span class="ggw-sukces-ico">${IKONY.ptaszek}</span>
      <h3 class="ggw-sukces-tytul"></h3>
      <p class="ggw-sukces-tresc"></p>
      <button type="button" class="ggw-wyslij ggw-sukces-x"></button>
    </div>
  </div>
</div>`;

  const uruchom = () => {
    const korzen = document.createElement("div");
    korzen.className = "ggw-root";
    korzen.innerHTML = SZKIELET;
    document.body.appendChild(korzen);

    const q = (sel) => korzen.querySelector(sel);
    const el = {
      dymek: q(".ggw-dymek"),
      panel: q(".ggw-panel"),
      x: q(".ggw-x"),
      tytul: q(".ggw-tytul"),
      podtytul: q(".ggw-podtytul"),
      form: q(".ggw-form"),
      tryby: [...korzen.querySelectorAll(".ggw-tryb")],
      reszta: q(".ggw-reszta"),
      poleZam: q(".ggw-pole-zam"),
      order: q('[name="order_number"]'),
      email: q('[name="email"]'),
      imie: q('[name="imie"]'),
      wiadomosc: q('[name="wiadomosc"]'),
      hp: q(".ggw-hp"),
      statusBtn: q(".ggw-status-btn"),
      statusKarta: q(".ggw-status"),
      plikBtn: q(".ggw-plik-btn"),
      plikInput: q(".ggw-plik-input"),
      plikLista: q(".ggw-plik-lista"),
      blad: q(".ggw-blad"),
      wyslij: q(".ggw-wyslij"),
      sukces: q(".ggw-sukces"),
      sukcesTytul: q(".ggw-sukces-tytul"),
      sukcesTresc: q(".ggw-sukces-tresc"),
      sukcesX: q(".ggw-sukces-x"),
      zapros: q(".ggw-zapros"),
      wybierz: q(".ggw-wybierz"),
      trybyBox: q(".ggw-tryby"),
      plikiBox: q(".ggw-pliki"),
      okno: q(".ggw-czat"),
      lista: q(".ggw-czat-lista"),
      kropki: q(".ggw-kropki"),
      uwaga: q(".ggw-czat-uwaga"),
      pisanie: q(".ggw-czat-pisanie"),
      czatInput: q(".ggw-czat-input"),
      czatWyslij: q(".ggw-czat-wyslij"),
      koniec: q(".ggw-czat-koniec"),
      koniecTxt: q(".ggw-czat-koniec-txt"),
      czatWroc: q(".ggw-czat-wroc"),
      czatZakoncz: q(".ggw-czat-zakoncz"),
      dymekBadge: q(".ggw-dymek-badge"),
    };

    let pliki = [];
    let otwarty = false;
    let wysylanie = false;
    let stanCzas = 0;
    // Trwajaca rozmowa: { token, operator, ostatnieId, bledy, pierwsza, koniec }
    let czat = null;
    let timerCzatu = null;
    let scena = "formularz";
    let pisaneOstatnio = 0;
    // Nowe wiadomosci operatora przy zwinietym panelu - kropka na dymku.
    let nieprzeczytane = 0;
    /* Na dotyku programowy fokus pola tekstowego = klawiatura wyjezdza sama i
       zaslania rozmowe (zgloszone 07.08: otwarcie zwinietego czatu na iPhonie
       witalo klawiatura bez pola w zasiegu wzroku). Fokus w polach ustawiamy
       wylacznie na urzadzeniach z myszka - na dotyku robi to stukniecie klientki. */
    const DOTYK = Boolean(window.matchMedia && matchMedia("(pointer: coarse)").matches);
    const fokusujPole = (pole) => { if (!DOTYK) pole.focus({ preventScroll: true }); };

    /* Token trwajacej rozmowy zyje w sessionStorage (per karta) - rozmowa ma przezyc
       wejscie na inna podstrone sklepu. localStorage bylby zly: dwie karty = dwie
       rozne rozmowy, a wspolny klucz by je sklejal. */
    const KLUCZ_CZATU = "ggw_czat_v1";
    const zapiszCzatSesje = () => { try { if (czat && !czat.koniec) sessionStorage.setItem(KLUCZ_CZATU, czat.token); } catch { /* prywatny tryb */ } };
    const skasujCzatSesje = () => { try { sessionStorage.removeItem(KLUCZ_CZATU); } catch { /* jw. */ } };

    const aktualizujBadge = () => {
      el.dymekBadge.hidden = nieprzeczytane <= 0;
      el.dymekBadge.textContent = nieprzeczytane > 9 ? "9+" : String(nieprzeczytane || "");
    };

    /* Panel pokazuje jedna scene. Zaproszenie to TEN SAM formularz - znikaja
       pille, numer zamowienia i zalaczniki, a przycisk zaczyna rozmowe. Dzieki
       temu odbicie z czatu na formularz nic nie przepisuje: klientka caly czas
       pisze w tych samych polach. */
    const pokazScene = (nowa) => {
      scena = nowa;
      const zapros = nowa === "zaproszenie";
      el.form.hidden = !zapros && nowa !== "formularz";
      el.okno.hidden = nowa !== "rozmowa";
      el.sukces.hidden = nowa !== "sukces";
      el.panel.classList.toggle("ggw-czat-on", nowa === "rozmowa");
      el.zapros.hidden = !zapros;
      el.wybierz.hidden = false;
      el.trybyBox.hidden = false;
      // Zalacznikow w rozmowie nie ma - czat idzie tekstem, pliki dopiero w zgloszeniu.
      el.plikiBox.hidden = zapros;
      if (!tryb) el.reszta.hidden = true;
      else { el.reszta.hidden = false; el.poleZam.hidden = tryb !== "zamowienie"; odswiezStatusBtn(); }
      el.wyslij.textContent = t(zapros ? "czat_start" : "przycisk_wyslij");
      // Naglowek idzie za scena - inaczej po rozmowie zostawalby napis o czacie.
      el.podtytul.textContent = podtytul();
    };
    // Godziny zna Worker (bierze je z ustawien kontaktu) - do czasu odpowiedzi
    // naglowek nie zmysla wlasnych, bo na kazdym rynku sa inne.
    let stan = { tryb: "wiadomosc", online: false, godziny: "" };

    // Na starcie NIE MA nic poza dwoma pillami - klientka najpierw mowi, czego sprawa
    // dotyczy, i dopiero wtedy widzi formularz. Sciana pol na dzien dobry odstrasza.
    let tryb = null;
    const ustawTryb = (nowy, { odFokus = false } = {}) => {
      tryb = nowy === "zamowienie" ? "zamowienie" : "ogolne";
      el.reszta.hidden = false;
      el.tryby.forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.tryb === tryb)));
      el.poleZam.hidden = tryb !== "zamowienie";
      if (tryb === "ogolne") {
        el.order.value = "";
        el.statusKarta.hidden = true;
      }
      odswiezStatusBtn();
      odswiezTeksty();
      zapiszSzkic();
      if (odFokus) (tryb === "zamowienie" ? el.order : el.email).focus();
    };
    el.tryby.forEach((b) => b.addEventListener("click", () => ustawTryb(b.dataset.tryb, { odFokus: true })));

    // ---------- teksty ----------

    // Godziny sa osobnym zdaniem, a nie wstawka w zdaniu glownym - gdy Worker ich
    // nie poda, naglowek ma po prostu jedno zdanie mniej, bez wiszacego dwukropka.
    const podtytul = () => {
      // W rozmowie klientka rozmawia z MARKA, nie z konkretna osoba - imion
      // pracownikow nie pokazujemy (decyzja Daniela 03.08).
      if (czat) return "Gym Glamour";
      if (scena === "zaproszenie") return t("czat_podtytul");
      const g = String(stan.godziny || "").trim();
      return g ? `${t("podtytul_offline")} ${t("podtytul_godziny").replace("{godziny}", g)}` : t("podtytul_offline");
    };

    const odswiezTeksty = () => {
      el.dymek.setAttribute("aria-label", t("otworz"));
      el.dymek.title = t("otworz");
      el.tytul.textContent = t("naglowek");
      el.podtytul.textContent = podtytul();
      el.x.setAttribute("aria-label", t("zamknij"));
      el.x.title = t("zamknij");
      q(".ggw-l-tryb-ogolne").textContent = t("tryb_ogolne");
      q(".ggw-l-tryb-zam").textContent = t("tryb_zamowienie");
      q(".ggw-l-zam").textContent = t("pole_zamowienie");
      q(".ggw-l-zam-hint").textContent = t("pole_zamowienie_hint");
      q(".ggw-l-email").textContent = t(tryb === "zamowienie" ? "pole_email_zam" : "pole_email");
      q(".ggw-l-wybierz").textContent = t("wybierz_temat");
      q(".ggw-l-imie").textContent = t("pole_imie");
      q(".ggw-l-wiad").textContent = t("pole_wiadomosc");
      q(".ggw-l-pliki").textContent = t("pole_pliki");
      q(".ggw-l-status").textContent = t("przycisk_sprawdz_status");
      q(".ggw-l-status-hint").textContent = t("status_hint");
      el.wyslij.textContent = t(scena === "zaproszenie" ? "czat_start" : "przycisk_wyslij");
      el.sukcesTytul.textContent = t("wyslane_tytul");
      el.sukcesTresc.textContent = t("wyslane_tresc");
      el.sukcesX.textContent = t("zamknij");
      q(".ggw-l-czat-zapros").textContent = t("czat_zaproszenie");
      q(".ggw-l-czat-pod").textContent = t("czat_podtytul");
      el.czatInput.placeholder = t("czat_pole_wiadomosc");
      el.czatWroc.textContent = t("czat_wroc_do_formularza");
      el.czatZakoncz.textContent = t("czat_zakoncz");
      el.uwaga.textContent = t("czat_ostrzezenie");
      el.kropki.setAttribute("aria-label", t("czat_pisze"));
      el.czatWyslij.setAttribute("aria-label", t("przycisk_wyslij"));
    };

    // ---------- szkic ----------

    const POLA_SZKICU = ["order", "email", "imie", "wiadomosc"];
    let timerSzkicu = null;

    const zapiszSzkic = () => {
      try {
        const dane = { tryb };
        for (const p of POLA_SZKICU) dane[p] = el[p].value;
        localStorage.setItem(KLUCZ_SZKICU, JSON.stringify(dane));
      } catch { /* tryb prywatny - szkic to wygoda, nie funkcja krytyczna */ }
    };

    const wczytajSzkic = () => {
      try {
        const dane = JSON.parse(localStorage.getItem(KLUCZ_SZKICU) || "{}");
        for (const p of POLA_SZKICU) if (typeof dane[p] === "string" && dane[p]) el[p].value = dane[p];
        const cosJest = [dane.order, dane.email, dane.imie, dane.wiadomosc].some((x) => x && x.trim());
        if (cosJest) ustawTryb(dane.tryb === "zamowienie" || dane.order ? "zamowienie" : "ogolne");
      } catch { /* uszkodzony wpis - startujemy z pustym formularzem */ }
    };

    const skasujSzkic = () => {
      try { localStorage.removeItem(KLUCZ_SZKICU); } catch { /* jw. */ }
    };

    // ---------- pliki ----------

    const rysujPliki = () => {
      el.plikLista.innerHTML = "";
      pliki.forEach((p, i) => {
        const li = document.createElement("li");
        li.className = "ggw-plik-el";
        li.innerHTML = `<span class="ggw-plik-nazwa">${esc(p.name)}</span>
          <button type="button" class="ggw-plik-usun" data-i="${i}" aria-label="${esc(t("przycisk_usun_plik"))}">${IKONY.krzyzyk}</button>`;
        el.plikLista.appendChild(li);
      });
    };

    el.plikBtn.addEventListener("click", () => el.plikInput.click());

    const suma = () => pliki.reduce((s, p) => s + p.size, 0);

    el.plikInput.addEventListener("change", () => {
      let odrzucone = el.plikInput.files.length + pliki.length > MAX_PLIKOW;
      for (const p of el.plikInput.files) {
        if (pliki.length >= MAX_PLIKOW) break;
        pliki.push(p);
      }
      // Zdjecia z telefonu potrafia przekroczyc limit jednym plikiem - wycofujemy
      // ostatnio dodane, zamiast czyscic klientce cala liste.
      while (pliki.length && suma() > MAX_BAJTOW) { pliki.pop(); odrzucone = true; }
      if (odrzucone) pokazBlad(t("blad_plik"), false);
      el.plikInput.value = "";
      rysujPliki();
    });

    el.plikLista.addEventListener("click", (e) => {
      const btn = e.target.closest(".ggw-plik-usun");
      if (!btn) return;
      pliki.splice(Number(btn.dataset.i), 1);
      rysujPliki();
    });

    // ---------- bledy ----------

    const ukryjBlad = () => { el.blad.hidden = true; el.blad.innerHTML = ""; };

    function pokazBlad(tekst, mimoTo) {
      el.blad.innerHTML = esc(tekst) +
        (mimoTo ? ` <button type="button" class="ggw-mimo">${esc(t("przycisk_mimo_to"))}</button>` : "");
      el.blad.hidden = false;
      if (mimoTo) el.blad.querySelector(".ggw-mimo").addEventListener("click", () => wyslij(true));
    }

    // ---------- status zamowienia ----------

    const mozeStatus = () => tryb === "zamowienie" && Boolean(el.order.value.trim()) && el.email.value.includes("@");

    const odswiezStatusBtn = () => {
      // Podglad statusu dziala TAKZE przed rozmowa: klientka moze sprawdzic paczke
      // i wcale nie zaczynac czatu, a jesli zacznie - robi to z numerem w reku.
      const widoczny = mozeStatus();
      el.statusBtn.hidden = !widoczny;
      if (!widoczny) el.statusKarta.hidden = true;
    };

    const rysujStatus = (d) => {
      const wiersze = [];
      const wiersz = (klasa, html) => wiersze.push(
        `<div class="ggw-wiersz"><span class="ggw-kropka ${klasa}"></span><span>${html}</span></div>`
      );
      const link = (url, tekst) => {
        const u = bezpiecznyUrl(url);
        return u ? ` <a href="${esc(u)}" target="_blank" rel="noopener">${esc(tekst)}</a>` : "";
      };

      if (d.tor === "CANCELLED") wiersz("zly", `<strong>${esc(t("st_anulowane"))}</strong>`);

      const paczki = Array.isArray(d.paczki) ? d.paczki : [];
      if (paczki.length) {
        wiersze.push(`<div class="ggw-sekcja">${esc(t("st_paczki"))}</div>`);
        for (const p of paczki) {
          const jest = p.stan === "DELIVERED";
          const nr = `${esc(p.kurier || "")} ${esc(p.numer || "")}`.trim();
          wiersz(jest ? "ok" : "warn",
            `<strong>${esc(t(jest ? "st_dostarczona" : "st_w_drodze"))}</strong> ${nr}${link(p.url, t("st_sledz"))}`);
        }
      }

      const mag = d.magazyn || {};
      if (mag.spakowane || mag.przygotowanie) wiersz("warn", esc(t("st_przygotowanie")));

      const zwroty = Array.isArray(d.zwroty) ? d.zwroty : [];
      if (zwroty.length) {
        wiersze.push(`<div class="ggw-sekcja">${esc(t("st_zwroty"))}</div>`);
        for (const z of zwroty) {
          const klucz = z.stan === "REFUND_DONE" ? "st_zwrot_zakonczony"
            : z.stan === "REGISTERED" ? "st_zwrot_zarejestrowany" : "st_zwrot_w_toku";
          let txt = `<strong>${esc(t(klucz))}</strong>`;
          if (z.data) txt += ` <span class="ggw-szary">${esc(dataPl(z.data))}</span>`;
          if (z.termin) txt += ` ${esc(t("st_termin").replace("{data}", dataPl(z.termin)))}`;
          if (z.nadana && z.nadana.numer) {
            txt += ` <span class="ggw-szary">${esc(z.nadana.kurier || "")} ${esc(z.nadana.numer)}</span>`;
          }
          // Jeden link akcji na zwrot - klientka i tak konczy sprawe w returns.
          const akcja = z.podaj_przesylke || (z.doplata || {}).url || (z.etykieta_blad || {}).url ||
            (z.etykieta || {}).url || (z.nadana || {}).url;
          txt += link(akcja, t("st_szczegoly"));
          wiersz(z.stan === "REFUND_DONE" ? "ok" : "warn", txt);
        }
      }

      if (d.adres_zwrotu) {
        wiersze.push(`<div class="ggw-adres">${esc(d.adres_zwrotu).replace(/\n/g, "<br>")}</div>`);
      }

      const produkty = Array.isArray(d.produkty) ? d.produkty : [];
      if (produkty.length) {
        wiersze.push(`<div class="ggw-sekcja">${esc(t("st_produkty"))}</div>` + produkty.map((p) => {
          const foto = bezpiecznyUrl(p.zdjecie);
          const obraz = foto
            ? `<img src="${esc(foto)}" alt="" loading="lazy">`
            : '<span class="ggw-prod-brak"></span>';
          return `<div class="ggw-prod">${obraz}<span>${esc(p.ilosc)}× ${esc(p.nazwa)}</span></div>`;
        }).join(""));
      }

      if (!wiersze.length) wiersz("", esc(t("st_brak")));
      const numer = d.zamowienie ? ` <span class="ggw-szary">${esc(d.zamowienie)}</span>` : "";
      el.statusKarta.innerHTML =
        `<div class="ggw-status-tytul">${esc(t("przycisk_sprawdz_status"))}${numer}</div>${wiersze.join("")}`;
    };

    el.statusBtn.addEventListener("click", async () => {
      el.statusBtn.disabled = true;
      el.statusKarta.hidden = false;
      el.statusKarta.innerHTML = '<div class="ggw-spinner"></div>';
      try {
        const r = await fetch(`${API}/status-zamowienia`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            order_number: el.order.value.trim(),
            email: el.email.value.trim(),
            lang: jezyk,
          }),
        });
        const d = await r.json();
        if (!r.ok || d.ok === false) {
          // Podglad statusu leci 1:1 z kontaktu, wiec bledy maja tam ksztalt { error },
          // a nie nasze kody - po samym kodzie HTTP wiemy, ze para sie nie zgadza.
          const kod = (d && d.blad) || (r.status === 429 ? "za_duzo_prob" : r.status === 400 ? "para_nie_pasuje" : "");
          el.statusKarta.textContent = t(BLEDY[kod] || "st_blad");
        } else {
          rysujStatus(d);
        }
      } catch {
        el.statusKarta.textContent = t("st_blad");
      } finally {
        el.statusBtn.disabled = false;
      }
    });

    // ---------- wysylka ----------

    async function wyslij(bezWeryfikacji) {
      if (wysylanie) return;
      const email = el.email.value.trim();
      const tresc = el.wiadomosc.value.trim();
      if (!email || !tresc) return pokazBlad(t("blad_brak_pol"), false);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return pokazBlad(t("blad_email"), false);

      wysylanie = true;
      ukryjBlad();
      el.wyslij.disabled = true;
      try {
        const fd = new FormData();
        fd.append("temat", TRYBY[tryb] || TRYBY.ogolne);
        fd.append("order_number", tryb === "zamowienie" ? el.order.value.trim() : "");
        fd.append("email", email);
        fd.append("imie", el.imie.value.trim());
        fd.append("wiadomosc", tresc);
        fd.append("lang", jezyk);
        fd.append("rynek", RYNEK);
        fd.append("website", el.hp.value);
        // Druga proba po "para_nie_pasuje" - Worker przekazuje flage do kontaktu,
        // ktory zaklada zgloszenie z verified=0 zamiast odbijac je po raz drugi.
        if (bezWeryfikacji) fd.append("mimo_to", "1");
        for (const p of pliki) fd.append("pliki", p);

        const r = await fetch(`${API}/wiadomosc`, { method: "POST", body: fd });
        const d = await r.json().catch(() => ({}));
        if (!r.ok || d.ok !== true) {
          const kod = d.blad || "";
          // Para zamowienie+e-mail nie pasuje - klientka moze wyslac tor niezweryfikowany.
          pokazBlad(t(BLEDY[kod] || "blad_ogolny"), Boolean(d.moge_wyslac_mimo_to) && !bezWeryfikacji);
          return;
        }
        skasujSzkic();
        pliki = [];
        rysujPliki();
        pokazScene("sukces");
        el.sukcesX.focus();
      } catch {
        pokazBlad(t("blad_ogolny"), false);
      } finally {
        wysylanie = false;
        el.wyslij.disabled = false;
      }
    }

    // Ten sam przycisk: w trybie czatu zaczyna rozmowe, poza nim wysyla zgloszenie.
    el.form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (scena === "zaproszenie") zacznijCzat(); else wyslij(false);
    });

    // ---------- rozmowa na zywo ----------

    /* Awatar przychodzi z kontaktu jako gotowy HTML. Wstawiamy go przez sito -
       widget siedzi na sklepie, wiec nic wykonywalnego nie ma tam prawa trafic,
       nawet z naszego wlasnego API. */
    const czysteHtml = (html) => {
      const box = document.createElement("div");
      box.innerHTML = String(html || "");
      box.querySelectorAll("script,iframe,object,embed,link,style,form").forEach((n) => n.remove());
      for (const n of box.querySelectorAll("*")) {
        for (const a of [...n.attributes]) {
          if (/^on/i.test(a.name) || /javascript:/i.test(a.value)) n.removeAttribute(a.name);
        }
      }
      return box.innerHTML;
    };

    const adres = (token, ogon = "") => `${API}/czat/${encodeURIComponent(token)}${ogon}`;
    const doDolu = () => { el.lista.scrollTop = el.lista.scrollHeight; };
    const ustawPisze = (czy) => { el.kropki.hidden = !czy; if (czy) doDolu(); };
    // Ostrzezenie i koniec liczy kontakt - widget nie prowadzi wlasnych zegarow.
    // Uwaga o zamknieciu ZAWSZE zajmuje swoj wiersz - gdyby znikala z ukladu,
    // pole wiadomosci skakalo by w gore i w dol co dwie sekundy.
    const ustawUwage = (czy) => { el.uwaga.classList.toggle("widac", Boolean(czy)); };

    const dodajBank = (m) => {
      const odOp = m.od === "operator";
      const kto = odOp ? "Gym Glamour" : t("czat_ty");
      const div = document.createElement("div");
      div.className = `ggw-bak ${odOp ? "ggw-bak-op" : "ggw-bak-ja"}`;
      div.innerHTML =
        `<span class="ggw-bak-tresc">${kto ? `<span class="ggw-bak-kto">${esc(kto)}</span>` : ""}` +
        `${linkujTekst(m.tresc).replace(/\n/g, "<br>")}<span class="ggw-bak-stan"></span></span>`;
      el.lista.appendChild(div);
      el.lista.appendChild(el.kropki); // kropki na koncu watku
      doDolu();
      return div;
    };

    const zakonczCzat = (powod) => {
      if (!czat || czat.koniec) return;
      czat.koniec = true;
      czat.zerwane = powod !== "zakonczony";
      skasujCzatSesje();
      clearInterval(timerCzatu);
      ustawPisze(false);
      ustawUwage(false);
      el.pisanie.hidden = true;
      el.czatZakoncz.hidden = true;
      el.koniecTxt.textContent = t(czat.zerwane ? "czat_brak_polaczenia" : "czat_zakonczony");
      el.koniec.hidden = false;
      if (otwarty) el.czatWroc.focus({ preventScroll: true });
    };

    // Klientka nie zostaje z niczym - to, co napisala, wraca do formularza.
    const naFormularz = (tresc) => {
      if (tresc) el.wiadomosc.value = tresc;
      ustawTryb(tryb || "ogolne"); // zapisze tez szkic
      pokazScene("formularz");
      fokusujPole(el.wiadomosc);
    };

    const zamknijWatek = () => {
      // Po zerwanym polaczeniu wraca tresc z pola; po normalnym koncu rozmowy
      // klientka ma juz caly zapis mailem.
      const tresc = czat && czat.zerwane ? (el.czatInput.value.trim() || czat.pierwsza) : "";
      czat = null;
      el.lista.replaceChildren(el.kropki);
      el.czatInput.value = "";
      naFormularz(tresc);
    };

    /* Rozmowe konczy WYLACZNIE jawna decyzja: ten przycisk, operator albo bezpiecznik
       ciszy na serwerze (5 min). Do 07.08 konczylo ja tez zamkniecie panelu i wyjscie
       ze strony - na mobile panel zaslania caly ekran, wiec "zamkne na chwile" ucinalo
       korespondencje w pol slowa (decyzja Daniela: zwiniecie ma byc zwinieciem). */
    const zakonczRecznie = () => {
      if (!czat || czat.koniec) return;
      const token = czat.token;
      zakonczCzat("zakonczony");
      // Bledu nie lapiemy celowo - gdy nie dojdzie, domknie ja bezpiecznik ciszy.
      fetch(adres(token, "/koniec"), { method: "POST", keepalive: true }).catch(() => {});
    };

    const odpytaj = async () => {
      if (!czat || czat.koniec) return;
      try {
        // Sygnal „klientka pisze" jedzie na tym samym odpytywaniu - osobne zadanie
        // co dwie sekundy dokladaloby drugie tyle ruchu za jedna flage.
        const pisze = Date.now() - pisaneOstatnio < CZAS_ODPYTANIA * 2 ? "&pisze=1" : "";
        // Potwierdzenie odczytu: TYLKO gdy panel jest otwarty na rozmowie i karta jest
        // na wierzchu - inaczej „przeczytano" u operatora znaczyloby tyle, co „doszlo",
        // a on ma z tego wiedziec, ze klientka naprawde ma jego wiadomosc na ekranie.
        const widzi = otwarty && !document.hidden && el.okno && !el.okno.hidden ? "&widzi=1" : "";
        const r = await fetch(adres(czat.token, `?od=${czat.ostatnieId}${pisze}${widzi}`));
        if (!r.ok) throw new Error("http");
        const d = await r.json();
        if (!czat) return; // panel mogl sie zamknac w trakcie lotu
        czat.bledy = 0;
        for (const m of (Array.isArray(d.wiadomosci) ? d.wiadomosci : [])) {
          const id = Number(m.id) || 0;
          if (id <= czat.ostatnieId) continue;
          czat.ostatnieId = id;
          // Wlasne banki wisza od razu - z serwera bierzemy tylko operatora.
          if (m.od === "operator") {
            dodajBank(m);
            // Panel zwiniety - klientka przegląda sklep. Kropka na dymku mowi,
            // ze operator odpisal, zanim rozmowa zdazy sie sama zamknac.
            if (!otwarty) { nieprzeczytane += 1; aktualizujBadge(); }
          }
        }
        ustawPisze(Boolean(d.pisze) && !d.zamkniety);
        ustawUwage(Boolean(d.ostrzezenie) && !d.zamkniety);
        if (d.zamkniety) {
          if (!otwarty) { nieprzeczytane += 1; aktualizujBadge(); }
          zakonczCzat("zakonczony");
        }
      } catch {
        if (czat && ++czat.bledy >= LIMIT_BLEDOW) zakonczCzat("brak_polaczenia");
      }
    };

    let ostatniaDlugosc = 0;
    const autoWysokosc = () => {
      const ta = el.czatInput;
      // Zerowanie wysokosci przed pomiarem powoduje mrugniecie na kazdy znak.
      // Robimy je tylko przy skracaniu tekstu - przy pisaniu wystarczy rosnac.
      if (ta.value.length < ostatniaDlugosc) ta.style.height = "auto";
      ostatniaDlugosc = ta.value.length;
      const docelowa = Math.max(40, Math.min(ta.scrollHeight, 110));
      if (Math.abs(parseFloat(ta.style.height) || 0) !== docelowa) ta.style.height = `${docelowa}px`;
    };

    const wyslijCzat = async () => {
      const tresc = el.czatInput.value.trim();
      if (!czat || czat.koniec || !tresc) return;
      el.czatInput.value = "";
      pisaneOstatnio = 0; // wyslana tresc to koniec pisania, nie jego ciag dalszy
      autoWysokosc();
      const bank = dodajBank({ od: "klientka", tresc });
      const znacznik = bank.querySelector(".ggw-bak-stan");
      znacznik.textContent = t("czat_wysylanie");
      try {
        const r = await fetch(adres(czat.token), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ tresc }),
        });
        const d = await r.json().catch(() => ({}));
        if (!r.ok || d.ok !== true) throw new Error("nie");
        if (czat) czat.bledy = 0;
        znacznik.remove();
      } catch {
        // Nieudana wysylka nie moze zjesc tekstu - bank znika, tresc wraca do pola.
        bank.remove();
        if (!czat) return;
        el.czatInput.value = tresc;
        autoWysokosc();
        if (++czat.bledy >= LIMIT_BLEDOW) zakonczCzat("brak_polaczenia");
      }
    };

    const zacznijCzat = async () => {
      if (wysylanie) return;
      const email = el.email.value.trim();
      const tresc = el.wiadomosc.value.trim();
      // E-mail jest wymagany, bo po zamknieciu rozmowy leci na niego caly zapis.
      if (!email || !tresc || !tryb) return pokazBlad(t("blad_brak_pol"), false);
      if (tryb === "zamowienie" && !el.order.value.trim()) return pokazBlad(t("blad_brak_pol"), false);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return pokazBlad(t("blad_email"), false);

      wysylanie = true;
      ukryjBlad();
      el.wyslij.disabled = true;
      el.wyslij.textContent = t("czat_wysylanie");
      try {
        const r = await fetch(`${API}/czat/start`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            imie: el.imie.value.trim(),
            email,
            wiadomosc: tresc,
            order_number: tryb === "zamowienie" ? el.order.value.trim() : "",
            lang: jezyk,
            rynek: RYNEK,
          }),
        });
        const d = await r.json().catch(() => ({}));
        if (!r.ok || d.ok !== true || !d.token) {
          /* Ostatni wolny operator wlasnie kogos wzial - tresc przechodzi do
             zwyklego formularza, bo klientka nie moze zostac z niczym.
             Limit tempa (jedna rozmowa na 5 minut) to osobna historia: „polaczenie
             sie urwalo" bylo tu klamstwem, bo polaczenie dziala. */
          naFormularz(tresc);
          const kod = d.blad === "brak_operatora" ? "czat_brak_operatora"
            : d.blad === "za_duzo_prob" ? "blad_limit" : "czat_brak_polaczenia";
          pokazBlad(t(kod), false);
          return;
        }
        czat = { token: String(d.token), operator: d.operator || null, ostatnieId: 0,
          bledy: 0, pierwsza: tresc, koniec: false, zerwane: false };
        zapiszCzatSesje();
        el.lista.replaceChildren(el.kropki);
        el.pisanie.hidden = false;
        el.czatZakoncz.hidden = false;
        el.koniec.hidden = true;
        ustawUwage(false);
        ustawPisze(false);
        pokazScene("rozmowa");
        dodajBank({ od: "klientka", tresc });
        // Pierwsza wiadomosc wisi juz w watku - pole ma byc puste.
        el.wiadomosc.value = "";
        zapiszSzkic();
        timerCzatu = setInterval(odpytaj, CZAS_ODPYTANIA);
        fokusujPole(el.czatInput);
      } catch {
        naFormularz(tresc);
        pokazBlad(t("czat_brak_polaczenia"), false);
      } finally {
        wysylanie = false;
        el.wyslij.disabled = false;
        el.wyslij.textContent = t(scena === "zaproszenie" ? "czat_start" : "przycisk_wyslij");
      }
    };

    el.czatWyslij.addEventListener("click", wyslijCzat);
    el.czatWroc.addEventListener("click", zamknijWatek);
    el.czatZakoncz.addEventListener("click", zakonczRecznie);
    el.czatInput.addEventListener("input", () => { autoWysokosc(); pisaneOstatnio = Date.now(); });
    // Enter wysyla, Shift+Enter robi nowa linie - jak w kazdym czacie.
    el.czatInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); wyslijCzat(); }
    });
    // Celowo BEZ pagehide/koniec: rozmowa ma przezyc przejscie na inna podstrone
    // sklepu (token w sessionStorage, przywracanie nizej). Porzucona na dobre
    // rozmowe domyka bezpiecznik ciszy na serwerze.

    /* Przywrocenie rozmowy po przejsciu na inna podstrone: token z sessionStorage,
       caly watek z serwera (?od=0). Panelu nie otwieramy sami - jesli ostatnie slowo
       nalezy do operatora, dymek dostaje kropke. Rozmowa zamknieta w miedzyczasie
       (bezpiecznik, operator) = po prostu czysty formularz, zapis i tak szedl mailem. */
    const przywrocCzat = async () => {
      let token = null;
      try { token = sessionStorage.getItem(KLUCZ_CZATU); } catch { return; }
      if (!token) return;
      try {
        const r = await fetch(adres(token, "?od=0"));
        if (!r.ok) { if (r.status === 404) skasujCzatSesje(); return; }
        const d = await r.json();
        if (d.zamkniety) { skasujCzatSesje(); return; }
        czat = { token: String(token), operator: null, ostatnieId: 0, bledy: 0,
          pierwsza: "", koniec: false, zerwane: false };
        el.lista.replaceChildren(el.kropki);
        let ostatniOd = null;
        for (const m of (Array.isArray(d.wiadomosci) ? d.wiadomosci : [])) {
          const id = Number(m.id) || 0;
          if (id > czat.ostatnieId) czat.ostatnieId = id;
          if (m.od !== "operator" && m.od !== "klientka") continue;
          dodajBank(m);
          ostatniOd = m.od;
        }
        el.pisanie.hidden = false;
        el.czatZakoncz.hidden = false;
        el.koniec.hidden = true;
        ustawUwage(false);
        ustawPisze(false);
        pokazScene("rozmowa");
        timerCzatu = setInterval(odpytaj, CZAS_ODPYTANIA);
        if (ostatniOd === "operator") { nieprzeczytane = 1; aktualizujBadge(); }
      } catch { /* nie udalo sie przywrocic - nastepna podstrona sprobuje ponownie */ }
    };
    przywrocCzat();

    // ---------- otwieranie i zamykanie ----------

    const FOKUS = 'a[href],button,input,select,textarea,[tabindex]';

    const fokusowalne = () => [...el.panel.querySelectorAll(FOKUS)].filter((x) =>
      !x.disabled && x.tabIndex >= 0 && !x.hidden && (x.offsetWidth || x.offsetHeight));

    const naKlawisz = (e) => {
      if (e.key === "Escape") { e.preventDefault(); zamknij(); return; }
      if (e.key !== "Tab") return;
      const lista = fokusowalne();
      if (!lista.length) return;
      const pierwszy = lista[0];
      const ostatni = lista[lista.length - 1];
      if (e.shiftKey && document.activeElement === pierwszy) { e.preventDefault(); ostatni.focus(); }
      else if (!e.shiftKey && document.activeElement === ostatni) { e.preventDefault(); pierwszy.focus(); }
    };

    /* Odswiezamy przy kazdym otwarciu, nie czesciej niz co pol minuty - /stan to
       czysty odczyt z KV. Brak odpowiedzi = zostaje tryb "wiadomosc": awaria NIE
       moze pokazac czatu, ktorego nikt nie odbierze. */
    const pobierzStan = async () => {
      if (Date.now() - stanCzas < CZAS_STANU) return;
      stanCzas = Date.now();
      try {
        const r = await fetch(`${API}/stan?rynek=${encodeURIComponent(RYNEK)}`);
        const d = await r.json();
        if (!d || typeof d !== "object") return;
        stan = Object.assign(stan, d);
        const naZywo = stan.tryb === "czat";
        if ((scena === "formularz" || scena === "zaproszenie") && naZywo !== (scena === "zaproszenie")) {
          pokazScene(naZywo ? "zaproszenie" : "formularz");
          if (otwarty) { if (naZywo) fokusujPole(el.imie); else el.tryby[0].focus({ preventScroll: true }); }
        }
        el.podtytul.textContent = podtytul();
      } catch { /* naglowek ma tekst zapasowy - brak /stan nie blokuje formularza */ }
    };

    const otworz = () => {
      if (otwarty) return;
      otwarty = true;
      nieprzeczytane = 0;
      aktualizujBadge();
      el.panel.hidden = false;
      el.dymek.hidden = true;
      el.dymek.setAttribute("aria-expanded", "true");
      document.documentElement.classList.add("ggw-blokada");
      document.addEventListener("keydown", naKlawisz, true);
      pobierzStan();
      if (scena === "rozmowa") doDolu();
      const cele = { zaproszenie: el.imie, rozmowa: czat && czat.koniec ? el.czatWroc : el.czatInput, sukces: el.sukcesX };
      const cel = cele[scena] || el.tryby[0];
      if (DOTYK && (cel === el.imie || cel === el.czatInput)) el.x.focus({ preventScroll: true });
      else cel.focus({ preventScroll: true });
    };

    // Po wyslanej wiadomosci panel zostaje na potwierdzeniu; przy zamknieciu
    // wracamy do pustego formularza, zeby kolejne otwarcie nie zaczynalo sie
    // od cudzego "Dziekujemy".
    const zresetuj = () => {
      // Wolane wylacznie dla rozmow juz zakonczonych (zamknij pilnuje trwajacej),
      // ale sprzatamy stan i zegar na wypadek przyszlych wywolan z innych miejsc.
      czat = null;
      clearInterval(timerCzatu);
      el.form.reset();
      el.statusKarta.hidden = true;
      ukryjBlad();
      el.lista.replaceChildren(el.kropki);
      pokazScene(stan.tryb === "czat" ? "zaproszenie" : "formularz");
      odswiezStatusBtn();
    };

    const zamknij = () => {
      if (!otwarty) return;
      otwarty = false;
      // TRWAJACA rozmowa przezywa zwiniecie panelu: watek i odpytywanie zostaja,
      // nowe odpowiedzi zapala kropka na dymku. Reset dotyczy tylko potwierdzenia
      // wyslania i rozmow juz ZAKONCZONYCH - kolejne otwarcie nie moze zaczynac
      // sie od cudzego „Dziekujemy" ani od martwego watku.
      const trwa = scena === "rozmowa" && czat && !czat.koniec;
      if (!trwa && (scena === "sukces" || scena === "rozmowa")) zresetuj();
      el.panel.hidden = true;
      el.dymek.hidden = false;
      el.dymek.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("ggw-blokada");
      document.removeEventListener("keydown", naKlawisz, true);
      el.dymek.focus({ preventScroll: true });
    };

    el.dymek.addEventListener("click", otworz);
    el.x.addEventListener("click", zamknij);
    el.sukcesX.addEventListener("click", zamknij);

    // ---------- podpiecia pol ----------

    for (const p of POLA_SZKICU) {
      el[p].addEventListener("input", () => {
        clearTimeout(timerSzkicu);
        timerSzkicu = setTimeout(zapiszSzkic, 400);
        ukryjBlad();
      });
    }
    el.order.addEventListener("input", odswiezStatusBtn);
    el.email.addEventListener("input", odswiezStatusBtn);

    wczytajSzkic();
    odswiezTeksty();
    odswiezStatusBtn();

    window.GGWidget = {
      otworz,
      zamknij,
      ustawJezyk(kod) {
        jezyk = String(kod || "PL").toUpperCase();
        odswiezTeksty();
      },
    };
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", uruchom);
  else uruchom();
})();
